"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
// Norwegian
var strings = {
  prefixAgo: 'for',
  prefixFromNow: 'om',
  suffixAgo: 'siden',
  suffixFromNow: '',
  seconds: 'mindre enn et minutt',
  minute: 'ca. et minutt',
  minutes: '%d minutter',
  hour: 'ca. en time',
  hours: 'ca. %d timer',
  day: 'en dag',
  days: '%d dager',
  month: 'ca. en måned',
  months: '%d måneder',
  year: 'ca. et år',
  years: '%d år'
};
var _default = strings;
exports["default"] = _default;